export default function ($translate) {
    return {
        KEYS: {
            EE: 'EE',
            LV: 'LV',
            LT: 'LT'
        },
        LABELS: {
            EE: $translate.instant('enums.Estonia'),
            LV: $translate.instant('enums.Latvia'),
            LT: $translate.instant('enums.Lithuania')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/countries/index.js